import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  ScanToken: {},
  insurance: {},
  ScanProcess: {},
  faceMatch: {},
  error: null,
  loading: true,
};

export const scanProcess = createAsyncThunk(
  "ScanProcess",
  async ({ data }, thunkAPI) => {
    const headers = {
      "api-version": "v1",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
    };

    let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v3/scan/process?accessToken=${data?.accessToken}&invitationId=${data?.invitationId}&acuantTransactionId=${data?.acuantTransactionId}`;

    const payload = {
      selfie: data?.selfie, // This is the base64 image you want to send
    };

    try {
      const response = await axios.post(url, payload, { headers });

      if (response.data) {
        return {
          ScanProcess: response.data,
        };
      }

    } catch (error) {

      return thunkAPI.rejectWithValue({ error: error.message });

    }
  }
);

export const scanFacematch = createAsyncThunk(
  "ScanFacematch",
  async ({ data }, thunkAPI) => {
    const headers = {
      "api-version": "v1",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
    };

    let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v2/scan/facematch?accessToken=${data?.accessToken}`;

    const payload = {
      selfie: data?.selfie, // This is the base64 image you want to send
    };

    try {
      const response = await axios.post(url, payload, { headers });

      if (response.data) {
        return {
          ScanProcess: response.data,
        };
      }

    } catch (error) {

      return thunkAPI.rejectWithValue({ error: error.message });

    }
  }
);

export const scanToken = createAsyncThunk(
  "paladin/ScanToken",
  async ({ data }, thunkAPI) => {
    const headers = {
      "api-version": "v1",
      "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
    };
    let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v2/scan/custom/token?token=${data?.token}`;
    try {
      const response = await axios.post(url, null, { headers });
      if (response?.data) {
        return {
          ScanToken: response?.data,
        };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);

export const GetInsurance = createAsyncThunk(
  "paladin/GetInsurance",
  async ({ data }, thunkAPI) => {
    const headers = {
      "api-version": "v1",
      "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
    };
    let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v2/webid/insurance/?token=${data?.token}`;

    try {
      const response = await axios.post(url, null, { headers });
      if (response?.data) {
        return {
          insurance: response?.data,
        };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);

export const getFaceMatch = createAsyncThunk(
  "FaceMatch",
  async ({ data }, thunkAPI) => {
    let subscription = process.env.REACT_APP_SUBSCRIPTION_ID;
    const base64Data = data?.imageFront.split(",")[1];
    let body = {
      Settings: {
        SubscriptionId: subscription,
      },
      Data: {
        ImageOne: base64Data,
        ImageTwo: data?.selfie,
      },
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_FRM_ENDPOINT}/api/v1/facematch`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data) {
        return {
          faceMatch: response.data,
        };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const postProcessSSN = createAsyncThunk(
  "paladin/ProcessSSN",
  async ({ data }, thunkAPI) => {
    const headers = {
      "api-version": "v1",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
    };
    const url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v1/web/${data?.slug}`;
    try {
      const response = await axios.post(url, { token: data?.token, ssn4: data?.ssn4 }, { headers });
      if (response?.data) {
        return { ProcessSSN: response?.data };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error });
    }
  }
);

export const paladinSlice = createSlice({
  name: "Paladin",
  initialState,
  reducers: {
    reset: (state) => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getFaceMatch.fulfilled, (state, action) => {
      state.faceMatch = action.payload?.faceMatch;
    });
    builder.addCase(getFaceMatch.rejected, (state, action) => {
      state.faceMatch = initialState.faceMatch;
    });

    builder.addCase(scanToken.fulfilled, (state, action) => {
      state.ScanToken = action.payload?.ScanToken;
    });
    builder.addCase(scanToken.rejected, (state, action) => {
      state.ScanToken = initialState.ScanToken;
    });
    builder.addCase(GetInsurance.fulfilled, (state, action) => {
      state.insurance = action.payload?.insurance;
    });
    builder.addCase(GetInsurance.rejected, (state, action) => {
      state.insurance = initialState.insurance;
    });

    builder.addCase(scanProcess.fulfilled, (state, action) => {
      state.ScanProcess = action.payload?.ScanProcess;
    });
    builder.addCase(scanProcess.rejected, (state, action) => {
      state.ScanProcess = initialState.ScanProcess;
    });

    builder.addCase(scanFacematch.fulfilled, (state, action) => {
      state.ScanProcess = action.payload?.ScanProcess;
    });
    builder.addCase(scanFacematch.rejected, (state, action) => {
      state.ScanProcess = initialState.ScanProcess;
    });
  },
});

export const { reset } = paladinSlice.actions;
